
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type singleVehicleGarageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function singleVehicleGarageRT(): TemplateResult<singleVehicleGarageRTRootProps> {
    return _createElement('div', { 'className': 'garage-container' }, this.template === 'active' ? _createElement('div', {
        'className': 'active-container cmTemplate_active',
        'key': '33'
    }, _createElement('div', {}, window.Convermax.config?.selectYourVehicleTitle || _translate(`ymm_bar_title`)), _createElement('span', { 'className': 'material-symbols-outlined bike' }, ' two_wheeler ')) : null, this.template === 'locked' ? _createElement('div', {
        'className': 'locked-container cmTemplate_locked',
        'key': '305'
    }, _createElement('span', { 'className': 'model' }, this.vehicleString)) : null);
}
        export const componentNames = []